// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const CustomerSummary = t.struct({
    ckcId: t.String,
    displayName: t.String,
    id: t.String,
}, {
    name: 'CustomerSummary',
    strict: true,
});

export const getDefaultState = () => new CustomerSummary({
    ckcId: '',
    displayName: '',
    id: '',
});

export default CustomerSummary;
